// src/components/Soporte/VideoModal.jsx

import React from 'react';
import './VideoModal.css';

export default function VideoModal({ video, onClose }) {
  if (!video) return null;

  // Extraer ID del video de YouTube
  const getYoutubeEmbedUrl = (url) => {
    const videoId = url.split('/').pop().split('?')[0];
    return `https://www.youtube.com/embed/${videoId}`;
  };

  return (
    <div className="video-modal-overlay" onClick={onClose}>
      <div className="video-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="video-modal-header">
          <h5 className="mb-0">{video.icon} {video.titulo}</h5>
          <button className="btn-close" onClick={onClose}></button>
        </div>
        <div className="video-modal-body">
          <div className="ratio ratio-16x9">
            <iframe
              src={getYoutubeEmbedUrl(video.url)}
              title={video.titulo}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
          <p className="mt-3 text-muted small">{video.descripcion}</p>
        </div>
      </div>
    </div>
  );
}